export const SAT_PATHS = {
  MY_ASSESSMENTS: '/sat/my-assessments',
  SAT_LANDING: '/sat/organizational-compass'
} as const
